// Determines whether the agency Portal nav (Notion-backed pages) is visible to
// the current user. Historically gated by the `ShowAgencyPortal` cognito group
// or `isAgency`. Mutual brands (Forreston/Oakwood/CFM) opt their underwriting
// role in via the `underwritingCanViewAgencyPortal` brand feature flag. (#31094)
export const resolveShowAgencyPortal = ({
  showAgencyPortal,
  isAgency,
  canApproveUWReview,
  underwritingCanViewAgencyPortal
}) => !!(showAgencyPortal || isAgency || (canApproveUWReview && underwritingCanViewAgencyPortal));
